import { render, staticRenderFns } from "./CargoRotogram.vue?vue&type=template&id=a2a0c510"
import script from "./CargoRotogram.vue?vue&type=script&lang=js"
export * from "./CargoRotogram.vue?vue&type=script&lang=js"
import style0 from "./CargoRotogram.vue?vue&type=style&index=0&id=a2a0c510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports